import { render, staticRenderFns } from "./General.vue?vue&type=template&id=b1b6dc38&scoped=true"
import script from "./General.vue?vue&type=script&lang=js"
export * from "./General.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b6dc38",
  null
  
)

export default component.exports